import { createStore } from "redux";
import categoryReducer from "./reducers/categoryReducer";

export default createStore(categoryReducer);
